import {connect} from 'react-redux';
import React, {Component} from 'react';
import BugFixes from '../../components/BugFixes/BugFixes';
import utils from '../../utils/utils';
import {fetchPosts, search} from './../../actions';

class BugFixesController extends Component {
  static fetchData(dispatch, params) {
    return dispatch(fetchPosts(params));
  }

  render() {
    return (
      <BugFixes {...this.props}/>
    );
  }
}

function getPageHeaderDivs() {
  return {
    title: 'Updates & Releases',
    description: `Stay up-to-date with all of Wix's new products, updates, bugs fixes and more.
    Keep checking back to be the first to know about every update to Wix products.`
  };
}

function mapStateToProps(state) {
  const articlesContent = utils.parseItemsContent(state.posts.articles);
  return {
    loading: state.posts.loading,
    numPages: state.posts.numPages,
    page: state.posts.page,
    tag: state.posts.tag,
    title: state.posts.title,
    content: articlesContent,
    pageHeader: getPageHeaderDivs(),
    activeExperiments: state.experiments.active,
    locale: state.locale
  };
}

function mapDispatchToProps(dispatch) {
  return {
    search: params => dispatch(search(params))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BugFixesController);



// WEBPACK FOOTER //
// ./containers/BugFixes/BugFixes.js